module.exports = __webpack_public_path__ + "static/media/order_ready.925491fb.svg";